import { Button, Grid, TextField } from '@material-ui/core';
import GenericModal, { IGenericModalProps } from 'components/GenericModal/GenericModal';
import { SyncIcon } from 'components/Icons';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { assembleiasAssessorIncluirPergunta } from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from 'store/modules/ModalsReducer';
import ErrorHandler from 'utils/ErrorHandler';
import useStyles from './styles';

const MAX_MENSAGEM_LENGHT = 500;

export interface IIncluirPerguntaChatModalProps extends IGenericModalProps {
  key: string,
  idEvento: number,
  callbackSuccess: Function,
}

export interface IIncluirPerguntaChatModal extends IModalProps {
  genericProps?: IIncluirPerguntaChatModalProps,
}

export default ( { genericProps }: IIncluirPerguntaChatModal ) => {

  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [ salvando, setSalvando ] = useState<boolean>(false);
  const [ mensagem, setMensagem ] = useState<string>('');
  const [ mensagemBlur, setMensagemBlur ] = useState<boolean>(false);

  const mensagemIsValid = useMemo((): boolean => {
    return mensagem && mensagem.trim().length > 0 ? true : false
  }, [mensagem])

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      dispatch(modalsActionsClose(genericProps.key));
    }
  },[dispatch, genericProps])

  const toSubmmit = useCallback(() => {
    setSalvando(true);
    dispatch(
      assembleiasAssessorIncluirPergunta(
        genericProps!.idEvento,
        (mensagem as string).trim().substr(0, 500),
        () => {
          setSalvando(false);
          genericProps!.callbackSuccess();
          toClose();
        },
        error => {
          setSalvando(false);
          ErrorHandler(error.response!.data);
        }
      )
    )
  },[dispatch, genericProps, mensagem, toClose]);

  return (
    <GenericModal
      title={ t(`IncluirPerguntaChatModal.title`) }
      content={
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <TextField
              label={ t(`IncluirPerguntaChatModal.mensagemField.label`) }
              value={ mensagem }
              className={classes.textField}
              disabled={ salvando }
              onBlur={ () => setMensagemBlur(true) }
              onChange={ event => setMensagem(event.target!.value as string) }
              error={ mensagemBlur && !mensagemIsValid }
              helperText={ 
                <span className={classes.textFieldHelperText}>
                  <span className={classes.textFieldHelperTextItem}>
                    {
                      mensagemBlur && !mensagemIsValid ?
                      t(`IncluirPerguntaChatModal.mensagemField.errors.required`) : ''
                    }
                  </span>
                  <span className={classes.textFieldHelperTextItem}>
                    {mensagem.trim().length}/{MAX_MENSAGEM_LENGHT}
                  </span>
                </span>
              }
              inputProps={{
                maxLength: MAX_MENSAGEM_LENGHT
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.confirmButtom } container justify="space-between">
            <Button
              variant="outlined"
              color="primary"
              onClick={ () => toClose() }
              disabled={ salvando || !mensagemIsValid }
            >
              { t('IncluirPerguntaChatModal.cancelarButtonLabel') }
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={ () => toSubmmit() }
              disabled={ salvando || !mensagemIsValid }
              endIcon={ salvando ? <SyncIcon className="animation-rotate" /> : null }
            >
              { t('IncluirPerguntaChatModal.cadastrarButtonLabel') }
            </Button>
          </Grid>
        </Grid>
      }
      genericProps={{
        maxWidth: 'sm',
        onClose: salvando ? undefined : toClose,
      }}
    />
  );
}